import { render, staticRenderFns } from "./damagesView.pug?vue&type=template&id=59a81a2c&lang=pug&external"
import script from "./damagesView.js?vue&type=script&lang=js&external"
export * from "./damagesView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a81a2c')) {
      api.createRecord('59a81a2c', component.options)
    } else {
      api.reload('59a81a2c', component.options)
    }
    module.hot.accept("./damagesView.pug?vue&type=template&id=59a81a2c&lang=pug&external", function () {
      api.rerender('59a81a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesView/index.vue"
export default component.exports